// extracted by mini-css-extract-plugin
module.exports = {"container":"Index_container__OJ8m-","tabs":"Index_tabs__2Q9i_","tabswrap":"Index_tabswrap__Wb45G","tab":"Index_tab__jTx7v","active":"Index_active__30MkY"};